export default __webpack_public_path__ + "static/media/transporte_publico.1d500a25.png";